// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter--container--4949b3","alignEnd":"ModalFooter--alignEnd--14e6b4"};